import type { IconSvgObject } from './types';

const CameraAdd03Icon: IconSvgObject = [
  ["path", { d: "M2 8V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V8C22 6.89543 21.1046 6 20 6H16.5L15.0937 3.8906C14.7228 3.3342 14.0983 3 13.4296 3H10.5704C9.90166 3 9.2772 3.3342 8.90627 3.8906L7.5 6H4C2.89543 6 2 6.89543 2 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 9V17M16 13L8 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CameraAdd03Icon;
